import { Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { Subscription, Subject } from 'rxjs';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from '../../../services/api.service';
import { CommonService } from 'src/app/services/common.service';
import { PopoverController, IonContent } from '@ionic/angular';
import { PopoverComponent } from '../../../shared/components/popover/popover.component';
import { SearchpopoverComponent } from '../../../shared/components/searchpopover/searchpopover.component';
import { Page } from 'src/app/models/page.model';
import { MatSelect } from '@angular/material/select';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Location } from '@angular/common';

@Component({
  selector: 'app-subscriptiondetail',
  templateUrl: './subscriptiondetail.page.html',
  styleUrls: ['./subscriptiondetail.page.scss'],
})
export class SubscriptiondetailPage implements OnInit {

  @ViewChild('table') table: DatatableComponent;
  @ViewChild(MatSelect) mySelect: MatSelect;
  @ViewChild('focusconSettingValue', { static: false }) focusconSettingValue;


  rows = [];
  page = new Page();

  skip: number = 0;
  pageSize: number = 20;
  count: any;
  domainSubsriptionId:any;
  testModel:any="hello"


  itemsSelected: any = [];
  searchSubscription: Subscription;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  searchEvent: Subject<any>;

  locale: any;
  tempLocale: any;
  AllLocales: any = [];


  editing = {};
  showPage: boolean = false;
  deleteCount: any = [];;
  columnsWidth: any = [];
  checkSaved:boolean;
  invalidSettingValue: boolean = false;
  invalidSettingPeriod: boolean = false;
  settingPeriodData:any = [];
  tstforfocus:boolean;
  domainId:any;
  breadcrumb: any = {
    subscriptionName: null
  }
  subscriptionForm: FormGroup
  submitted: boolean = false
  controlStatus: any = {
    Phone: false,
  };
  subscriptions: any
  hideDelete: boolean = false

  constructor(private router: Router, private route: ActivatedRoute,private formBuilder: FormBuilder,private el: ElementRef, private _apiService: ApiService, public _commonService: CommonService, private popoverController: PopoverController, private location: Location) {
    this.searchEvent = this._commonService.searchTextValue;
  }

  ngOnInit() {
    this.subscriptionForm = this.formBuilder.group({
      Name: ['', Validators.required],
      Description: [''],
      PhoneNumber: ['', [Validators.pattern(this._commonService.phonePattern)]],
      IsSystemAdmin: [false]
    });
  }

  ionViewDidLeave(){
    this.editing = {};
    this.itemsSelected = [];

    // this.table.selected = [];
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.toggleSubscription) {
      this.toggleSubscription.unsubscribe();
    }
    if (this.resizeSubscription) this.resizeSubscription.unsubscribe();
  }

  ionViewDidEnter() {
    this.itemsSelected = [];
    this.domainId = localStorage.domainId;
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
    this.getLocales();
    this.settingPeriodData = [
      {
        code: 'PERIOD_MONTH',
        name:this._commonService.getLocalTranslation('label-month'),
      },
      {
        code: 'PERIOD_3MONTH',
        name:this._commonService.getLocalTranslation('label-3months'),
      },
      {
        code: 'PERIOD_6MONTH',
        name:this._commonService.getLocalTranslation('label-6months'),
      },
      {
        code: 'PERIOD_YEAR',
        name:this._commonService.getLocalTranslation('label-year')
      }

    ]
    this.domainSubsriptionId = this.route.snapshot.paramMap.get('id');
    if (this.domainSubsriptionId == '0') {
      this.domainSubsriptionId= null;
      this.subscriptions =
      {
        DomainSubscriptionId: this.domainSubsriptionId,
        PhoneNumber: '',
        IsSystemAdmin: false,
        Translations: [
          {
            LocaleId: this.locale,
            Name: '',
            Description: null,
          }
        ]
      }
    }
    if (this.domainSubsriptionId) {
      this.setPage({ offset: 0 }, "");
      if (this.searchEvent) {
        this.searchSubscription = this.searchEvent.subscribe(event => {
          this.setPage({ offset: 0 }, event);
        });
      }

      this.adjustColumnWidth();
      this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
        setTimeout( () => {
          if(this.table){
            this.rows = [...this.rows];
            this.table.recalculate();
          }
        },0)
      });
      this.resizeSubscription = this._commonService.onResize.subscribe(event => {
        this.adjustColumnWidth();
      });


    }


  }

  get f() { return this.subscriptionForm.controls; }

  async setPage(pageInfo, searchText) {

    try{
      this._commonService.presentLoading();
      this._commonService.currentPage = pageInfo.offset;
      this.page.pageNumber = pageInfo.offset;
      this.table.offset = this.page.pageNumber;
      let res = await this._apiService.getSubsciptionSettingDetail(this.domainSubsriptionId,this.domainId,searchText ? searchText : "", this.page.orderBy, this.page.orderDir, 1, 0);
      this.rows = res.body;
      this.rows.forEach(element => {
        element.Domain = this.domainId;
      });
      let r = await this._apiService.getSubsriptionDetail(this.domainSubsriptionId)
      this.subscriptions = r.body
      if( this.subscriptions.IsSystemAdmin == '0'){
        this.hideDelete = true
      }else{
        this.hideDelete = false
      }
      let subs = this.subscriptions.Translations.find(x => x.LocaleId == this.locale);
      this.breadcrumb.subscriptionName = subs.Name
      this.subscriptionForm.patchValue({
        Name:  subs.Name,
        Description:  subs.Description,
        PhoneNumber: this.subscriptions.PhoneNumber,
        IsSystemAdmin: Number(this.subscriptions.IsSystemAdmin) ? true : false,
      })
      this.showPage = true;

      this.table.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
      this.table.selected = [];
      if (!this.table.element.className.includes("border-header border-footer")) this.table.element.className += " border-header border-footer";
      this._commonService.dismiss();
      this.submitted = false
    }catch(error){
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }
  async onSort(event) {
    const sort = event.sorts[0];
    this.page.orderBy = sort.prop.toLowerCase();
    this.page.orderDir = sort.dir;
    this.setPage({ offset: this.page.pageNumber }, '');
  }

  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        let icon;
        this.AllLocales = JSON.parse(localStorage.domainLocales);
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      } else {
        let icon;
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.AllLocales = JSON.parse(localStorage.domainLocales);
        localStorage.domainLocales = JSON.stringify(localeData.body);
        for (let i = 0; i < this.AllLocales.length; i++) {
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  adjustColumnWidth() {
    if (this.table && window.innerWidth > 800) {
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.Subscription = (40 / 100) * tableWidth;
      this.columnsWidth.SettingValue = (30 / 100) * tableWidth;
      this.columnsWidth.SettingPeriod = (30 / 100) * tableWidth;
    }
    if (this.table && window.innerWidth < 800) {
      let tableWidth = this.table._innerWidth - 30;
      this.columnsWidth.SettingName = (40 / 100) * tableWidth;
      this.columnsWidth.SettingValue = (30 / 100) * tableWidth;
      this.columnsWidth.SettingPeriod = (30 / 100) * tableWidth;
    }
  }

  updateValue(event, cell, rowIndex, row) {
    console.log("TestModel",this.testModel)
    if(cell == "SettingValue"){
    if(row.isSettingValueInvalid && event != "") {
      row.isSettingValueInvalid = false;
      this.invalidSettingValue = false;
    }
  }
  if(cell == "SettingPeriod"){
    if(row.isSettingPeriodInvalid && event != "") {
      row.isSettingPeriodInvalid = false;
      this.invalidSettingPeriod = false;
    }
  }
    if(event != "" || this.rows[rowIndex][cell] !="" ){
      if(event != "" || event == row[cell]) {
        this.editing[rowIndex + '-' + cell] = false;
      }
      this.rows[rowIndex][cell] = event;
      let rowArray =[];
      rowArray.push(row);
      if(this.rows[rowIndex][cell] != row[cell]) {
        rowArray[rowIndex][cell] = event
      }
      this.rows = [...this.rows];
    }
  }

  focusAndEdit(cell, rowIndex) {
    this.editing[rowIndex + '-' + cell] = true;
    setTimeout(() => {
    if(cell == "SettingValue") {
        this.focusconSettingValue.setFocus();
        for(let i=0 ;i<this.rows.length;i++){
            this.editing[i + '-' + "SettingPeriod"] = false;
          }
      } else if(cell=="SettingPeriod"){
        for(let i=0 ;i<this.rows.length;i++){
          if(i!=rowIndex){
            this.editing[i + '-' + cell] = false;
          }
        }
        // this.focusconSettingPeriod.focus();

      }
    }, 0);

  }

  async onSubmit(){
    this.submitted = true;
    // stop here if form is invalid
    if (this.subscriptionForm.invalid) {
      this._commonService.scrollToError();
      this.controlStatus.Phone = true
      return;
    }
    if(!this.domainSubsriptionId){

    }

    let subscription = this.subscriptions.Translations.find(x => x.LocaleId == this.locale);
    subscription.Name = this.subscriptionForm.value.Name;
    this.subscriptions.Translations.forEach(x=>{
      if(x.LocaleId!=this.locale && (x.Name == null || x.Name == '')){
          x.Name = subscription.Name
      }
    }
    )
    subscription.Description = this.subscriptionForm.value.Description;
    this.subscriptions.PhoneNumber = this.subscriptionForm.value.PhoneNumber;
    this.subscriptions.DomainSubscriptionId = this.domainSubsriptionId;
    this.subscriptions.IsSystemAdmin =  this.subscriptionForm.value.IsSystemAdmin ? '1' : '0'

    if(this.domainSubsriptionId){

      this.table._internalRows.forEach( row => {

        if(row.SettingValue == "") {
          row.isSettingValueInvalid = true;
          this.invalidSettingValue = true;
        } else {
          row.isSettingValueInvalid = false;
        }
        if(row.SettingPeriod == ""){
          row.isSettingPeriodInvalid = true;
          this.invalidSettingPeriod = true;
        }else{
        row.isSettingPeriodInvalid = false;
        }
       });
       if(this.invalidSettingValue || this.invalidSettingPeriod){
         let rows = [];
        for (let i = 0; i < this.table._internalRows.length; i++) {
          if(this.table._internalRows[i].isSettingValueInvalid || this.table._internalRows[i].isSettingPeriodInvalid ) {
           rows.push(i)
          }
        }
        setTimeout(() => {
           if(this.table._internalRows[rows[0]].isSettingValueInvalid) {
            this.focusconSettingValue.setFocus();
          }
          this.table.element.querySelector('.datatable-body').scrollTop = rows[0] * 50;
        }, 0);
        this.invalidSettingValue = false;
         return;
       }
      this._commonService.presentLoading();
      try {
        let data = [];
        let color = "";
        let colorSecondary = "";
        this.rows.forEach( row => {
          if (row.SubscriptionSettingName != "" && row.SettingValue != ""){
            row.SubscriptionSettingName = row.SubscriptionSettingName.trim();
            data.push(row);
          }
        });
        this._commonService.log(data, this._commonService.LOG);
        await this._apiService.postSubsription(this.subscriptions)
        await this._apiService.postSubsciptionSetting(data);
        var i=0;
        this.rows.forEach( row => {
          i++;

        this.editing[i + '-SettingValue'] = false;

        });
        this._commonService.dismiss();
        this.setPage({ offset: 0 }, "");
        this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
      } catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    }else{
      try {
        this._commonService.presentLoading()
        let res = await this._apiService.postSubsription(this.subscriptions)
        if(res.id){
          this.domainSubsriptionId = res.id
          this.location.replaceState("maintenance/subscriptionsettings/" + this.domainSubsriptionId);
        }
        await this.adjustColumnWidth();
        this.setPage({ offset: 0 }, "");
        this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));
        this._commonService.dismiss();
      } catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    }
  }

  changeLocale() {
      if (this.domainSubsriptionId && this.subscriptions.Translations) {
        let tempFolder = this.subscriptions.Translations.find(x => x.LocaleId == this.tempLocale);
        tempFolder.Name = this.subscriptionForm.value.Name;
        tempFolder.Description = this.subscriptionForm.value.Description;
        this.tempLocale = this.locale;
        let folder = this.subscriptions.Translations.find(x => x.LocaleId == this.locale);
        if(folder){
          this.subscriptionForm.patchValue({
            Name: folder.Name,
            Description: folder.Description,
          });
        }else{
          this.subscriptions.Translations.push({
            Name: '',
            Description: '',
            LocaleId: this.locale,
          });
          this.subscriptionForm.controls['Name'].reset();
          this.subscriptionForm.controls['Description'].reset();
        }
      } else {
        let tempFolder = this.subscriptions.Translations.find(x => x.LocaleId == this.tempLocale);
        if (tempFolder) {
          tempFolder.Name = this.subscriptionForm.value.Name;
          tempFolder.Description = this.subscriptionForm.value.Description;
          this.tempLocale = this.locale;

          let folder = this.subscriptions.Translations.find(x => x.LocaleId == this.locale);
          if (folder) {
            this.subscriptionForm.patchValue({
              Name: folder.Name,
              Description: folder.Description,
            });
          }
          else {
            this.subscriptions.Translations.push({
              Name: '',
              Description: '',
              LocaleId: this.locale,
            });
            this.subscriptionForm.controls['Name'].reset();
            this.subscriptionForm.controls['Description'].reset();
            this.tempLocale = this.locale;
          }
        }
      }

  }


  onBlurMethod(controlName){
   if(controlName == 'Phone'){
    this.controlStatus.Phone = true
  }

   }

   onFocusMethod(controlName){
     if(controlName == 'Phone'){
      this.controlStatus.Phone = false
    }

   }

  goBack() {
   this.subscriptionForm.reset()
    this._commonService.searchText = '';
    this._commonService.currentPage = 0;
    this._commonService.goBack('maintenance/subscriptionsettings');
  }


  onActionChange(obj){
    switch (obj.Action) {
      case "save":
        this.onSubmit();
        break;
      case "search":
          this.setPage({ offset: 0 }, obj.Event);
          break;
      case "close":
        this.setPage({ offset: 0 }, '');
        break;
        case "delete":
          this.delete();
          break;
      case "backToList":
            this.goBack();
            break;
     case "backToMain":
            this.router.navigate(['maintenance'], { replaceUrl: true })
            break;
       case "back":
            this.goBack();
            break;
      }
  }


  delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteSubscription(this.domainSubsriptionId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.table.selected = [];
          this.itemsSelected = [];
         this.goBack()
        } catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
        }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
      })
  }

  onSelect(event){

  }





}
